var App = App || {};
App.Initialization = App.Initialization || {};

App.Initialization['widget.ratesBand'] = (function () {
    'use strict';

    const initialize = (widget) => {
        const carouselEl = widget.querySelector(".splide");
        if (carouselEl) carousel(widget, carouselEl);
    }

    const carousel = (widget, carousel) => {
        var desktopCarousel = carousel.getAttribute('data-desktop');

        const splideOptions = {
            pagination: false,
            type: 'loop',
            fixedWidth: "300px",
            gap: "30px",
            drag: true,
            snap: false,
            perMove: 1,
            destroy: desktopCarousel == "False",
            breakpoints: {
                1199: {
                    gap: "15px"
                },
                991: {
                    fixedWidth: "238px",
                    destroy: desktopCarousel == "False"
                },
                575: {
                    destroy: false
                }
            }
        };

        App.Helpers.splideFallback(
            carousel,
            splideOptions,
            function (splide) {
                splideEventBindings(widget, splide, carousel);
            }
        );
    }

    const splideEventBindings = (widget, splide, carousel) => {
        const prevBtn = widget.querySelectorAll("button.splide-control.btn-previous");
        const nextBtn = widget.querySelectorAll("button.splide-control.btn-next");

        prevBtn.forEach(button => {
            button.addEventListener("click", function () {
                splide.go('-1')
            });
        });

        nextBtn.forEach(button => {
            button.addEventListener("click", function () {
                splide.go('+1')
            });
        });
    }

    return {
        initialize
    };

})();